<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Panel</label>
        <v-select
          :value="panelFilter"
          :options="panelOptions"
          class="w-100"
          :multiple="false"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:panelFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("intelbras.alarm_type_sbo") }}</label>
        <v-select
          :value="typeAlarmFilter"
          :options="typeAlarmOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:typeAlarmFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("intelbras.event_code") }}</label>
        <v-select
          :value="eventCodeFilter"
          :options="eventCodeOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:eventCodeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("alarm.start_date_filter") }}</label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="startDatetime"
          @on-change="(selectedDates, val) => $emit('update:startDatetime', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("alarm.end_date_filter") }}</label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="endDatetime"
          @on-change="(selectedDates, val) => $emit('update:endDatetime', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {BCard, BCardHeader, BCardBody, BRow, BCol, BButton} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    flatPickr,
  },
  props: {
    typeAlarmOptions: {
      type: Array,
    },
    typeAlarmFilter: {
      default: null,
    },
    eventCodeOptions: {
      type: Array,
    },
    eventCodeFilter: {
      default: null,
    },
    panelOptions: {
      type: Array,
    },
    panelFilter: {
      default: null,
    },
    startDatetime: {
      type: String,
      default: null,
    },
    endDatetime: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
